module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10024_easter.2ab721a6.jpg";